const BENEFICIARY_RELATIONSHIP = {
    business_partner: 'Socio',
    child: 'Hijo/Hija',
    child_in_law: 'Yerno/Nuera',
    cousin: 'Primo/Prima',
    father: 'Padre',
    friend: 'Amigo/Amiga',
    godchild: 'Ahijado/Ahijada',
    godparent: 'Compadre/Comadre',
    grandchild: 'Nieto/Nieta',
    grandparent: 'Abuelo/Abuela',
    mother: 'Madre',
    niece_nephew: 'Sobrino/Sobrina',
    parent_in_law: 'Suegro/Suegra',
    partner: 'Concubino/Concubina',
    sibling: 'Hermano/Hermana',
    sibling_in_law: 'Cuñado/Cuñada',
    spouse: 'Cónyuge',
    stepchild: 'Hijastro/Hijastra',
    stepparent: 'Padrastro/Madrastra',
    uncle_aunt: 'Tío/Tía'
};
export default BENEFICIARY_RELATIONSHIP;
